import React from 'react';
import styled from '@emotion/styled';
import { IconCalendar, IconCircleXFill } from '../icons/generated';
import { semantic_colors } from '../../foundation';
import { Stack } from '../stack';

export interface DatePickerIconProps {
  showRemoveIcon?: boolean;
  onClick?: () => void;
}

export const DatePickerIcon = ({ showRemoveIcon, onClick }: DatePickerIconProps) => {
  return (
    <Stack direction='row' align='center'>
      {showRemoveIcon ? (
        <RemoveButton
          type='button'
          onClick={(e) => {
            e.stopPropagation();
            onClick?.();
          }}
        >
          <IconCircleXFill size={16} color={semantic_colors.content.tertiary} />
        </RemoveButton>
      ) : (
        <IconCalendar size={16} color={semantic_colors.content.tertiary} />
      )}
    </Stack>
  );
};

export const RemoveButton = styled.button`
  padding: 0;
  display: flex;
  align-items: center;
  flex: 0 0 auto;
  border: 1px solid transparent;
  background: transparent;
  cursor: pointer;
`;
